// extracted by mini-css-extract-plugin
module.exports = {"listStyle":"FoodList_listStyle__vkoOu"};